import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { withParentSize } from '@visx/responsive';
import ScenarioSelectionDetailedSummaryLayout
  from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionAssumptionsAndDetails/Layout/ScenarioSelectionDetailedSummaryPicker/ScenarioSelectionDetailedSummary/ScenarioSelectionDetailedSummaryLayout';
import { useFilterContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/FilterContext';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import {
  ScenarioDetailTableProvider,
} from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionAssumptionsAndDetails/Layout/ScenarioSelectionDetailedSummaryPicker/ScenarioSelectionDetailedSummary/ScenarioDetailTableContext';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(0, 4),
  },
});

const ScenarioDetailsTabTemplate = withParentSize(
  ({
    className,
    classes,
    parentHeight,
  }) => {
    const { setAllocationsTimeframe } = useFilterContext();
    const { activeTabResource } = useTabContentContext();

    const handleOnChangePeriod = value => {
      setAllocationsTimeframe(value);
    };

    return (
      <Box
        className={classNames(classes.root, className)}
      >
        <ScenarioDetailTableProvider resource={activeTabResource}>
          <ScenarioSelectionDetailedSummaryLayout height={parentHeight} showMonthsProp hasMaxWidth={false} handleOnChangePeriod={handleOnChangePeriod} dense />
        </ScenarioDetailTableProvider>
      </Box>
    );
  },
);

ScenarioDetailsTabTemplate.defaultProps = {
  className: '',
};

ScenarioDetailsTabTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScenarioDetailsTabTemplate);
